var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYourTv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "television-core-small",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2 53.3992C37.2 52.7365 36.6628 52.1992 36 52.1992H34.8C34.1373 52.1992 33.6 52.7365 33.6 53.3992V56.2636C33.6 56.9129 33.0834 57.4433 32.4347 57.4739C30.3013 57.5744 28.1719 57.7834 26.0546 58.1011L19.444 59.0926C18.2692 59.2688 17.4 60.2782 17.4 61.4662V62.0992C17.4 62.4304 17.6686 62.6992 18 62.6992H52.8C53.1314 62.6992 53.4 62.4304 53.4 62.0992V61.4662C53.4 60.2782 52.5309 59.2688 51.3561 59.0926L44.7454 58.1011C42.6282 57.7834 40.4987 57.5744 38.3653 57.4739C37.7167 57.4433 37.2 56.9129 37.2 56.2636V53.3992Z",
    fill: "url(\"#paint0_radial_5179_1308\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6 60.7388C18.6 60.2306 18.9587 59.796 19.4602 59.711C22.0196 59.2775 29.7585 58.0508 35.4 58.0508C41.0415 58.0508 48.7804 59.2775 51.3398 59.711C51.8412 59.796 52.2 60.2306 52.2 60.7388C52.2 60.902 52.0575 61.0268 51.8967 61.0004C50.1219 60.707 40.9704 59.2409 35.4 59.2409C29.8295 59.2409 20.678 60.707 18.9033 61.0004C18.7425 61.0268 18.6 60.902 18.6 60.7388Z",
    fill: "url(\"#paint1_radial_5179_1308\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63 12H8.99995C8.00584 12 7.19995 12.8059 7.19995 13.8V51.6C7.19995 52.5941 8.00584 53.4 8.99995 53.4H63C63.9941 53.4 64.8 52.5941 64.8 51.6V13.8C64.8 12.8059 63.9941 12 63 12Z",
    fill: "url(\"#paint2_linear_5179_1308\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M63 12H8.99995C8.00584 12 7.19995 12.8059 7.19995 13.8V51.6C7.19995 52.5941 8.00584 53.4 8.99995 53.4H63C63.9941 53.4 64.8 52.5941 64.8 51.6V13.8C64.8 12.8059 63.9941 12 63 12Z",
    fill: "url(\"#paint3_radial_5179_1308\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99995 12.6H63C63.663 12.6 64.2 13.1372 64.2 13.8V50.4H7.79995V13.8C7.79995 13.1372 8.33719 12.6 8.99995 12.6ZM7.19995 50.4V13.8C7.19995 12.8059 8.00581 12 8.99995 12H63C63.9942 12 64.8 12.8059 64.8 13.8V50.4V51.6C64.8 52.5941 63.9942 53.4 63 53.4H8.99995C8.00581 53.4 7.19995 52.5941 7.19995 51.6V50.4Z",
    fill: "url(\"#paint4_radial_5179_1308\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M35.4 52.8C36.3941 52.8 37.2 52.3971 37.2 51.9C37.2 51.4029 36.3941 51 35.4 51C34.4059 51 33.6 51.4029 33.6 51.9C33.6 52.3971 34.4059 52.8 35.4 52.8Z",
    fill: "url(\"#paint5_radial_5179_1308\")"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3269 49.3723) rotate(118.526) scale(55.1579 46.2871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6F181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#5B1333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391945"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1077 53.6128) rotate(158.116) scale(32.7275 42.219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#99161D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#7D1845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59216E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5179_1308",
    x1: 10.4727,
    y1: 14.9572,
    x2: 56.1755,
    y2: 51.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99161D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245283,
    stopColor: "#CA005B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346698,
    stopColor: "#FF479A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46934,
    stopColor: "#CC3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735849,
    stopColor: "#BC1A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94FF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6181 23.8286) rotate(90) scale(25.9571 25.8545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0E20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C0E20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54 20.1938) rotate(144.293) scale(47.2897 44.8232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E50914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#A70D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792A95"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.525 51.3562) rotate(135) scale(4.58735)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFBDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F89DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3269 49.3723) rotate(118.526) scale(55.1579 46.2871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#6F181D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#5B1333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391945"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.1077 53.6128) rotate(158.116) scale(32.7275 42.219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#99161D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#7D1845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59216E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5179_1308",
    x1: 10.4727,
    y1: 14.9572,
    x2: 56.1755,
    y2: 51.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99161D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245283,
    stopColor: "#CA005B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346698,
    stopColor: "#FF479A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46934,
    stopColor: "#CC3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735849,
    stopColor: "#BC1A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94FF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6181 23.8286) rotate(90) scale(25.9571 25.8545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0E20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C0E20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54 20.1938) rotate(144.293) scale(47.2897 44.8232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E50914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#A70D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792A95"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5179_1308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.525 51.3562) rotate(135) scale(4.58735)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFBDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F89DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourTv);
export default __webpack_public_path__ + "static/media/your-tv.75de45910c3f91b7785815e1135aab4d.svg";
export { ForwardRef as ReactComponent };